/**
 * Estate Flow - Server-Side Analytics
 * Replaces client-side tracking scripts to avoid AV warnings
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Log analytics event to server
 * @param {string} eventName - Name of the event (e.g., 'page_view', 'signup', 'payment')
 * @param {object} eventData - Additional event data
 */
const logEvent = async (eventName, eventData = {}) => {
  try {
    const token = localStorage.getItem('access_token');
    
    await fetch(`${BACKEND_URL}/api/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      },
      body: JSON.stringify({
        event: eventName,
        data: eventData,
        timestamp: new Date().toISOString(),
        page: window.location.pathname,
        referrer: document.referrer,
        user_agent: navigator.userAgent
      })
    });
  } catch (error) {
    // Fail silently - analytics should never break the app
    console.debug('Analytics tracking failed:', error);
  }
};

// Exported tracking functions
export const trackPageView = (page = window.location.pathname) => {
  logEvent('page_view', { page });
};

export const trackSignup = (userType, email) => {
  logEvent('user_signup', { userType, email });
};

export const trackLogin = (userType) => {
  logEvent('user_login', { userType });
};

export const trackPayment = (amount, paymentType) => {
  logEvent('payment_completed', { amount, paymentType });
};

export const trackReferralGenerated = (referralCode) => {
  logEvent('referral_generated', { referralCode });
};

export const trackPromoCodeUsed = (promoCode) => {
  logEvent('promo_code_used', { promoCode });
};

export const trackFeatureUsed = (featureName) => {
  logEvent('feature_used', { featureName });
};

export default {
  trackPageView,
  trackSignup,
  trackLogin,
  trackPayment,
  trackReferralGenerated,
  trackPromoCodeUsed,
  trackFeatureUsed
};
